import {
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // CheckboxGroup多选Mobile数据源 筛选器
  ICONABLE_CHECKBOX_SELECT as ICONABLE_CHECKBOX_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
  // 是否显示前n个国家筛选器
  SHOW_TOP_COUNTRIES as SHOW_TOP_COUNTRIES_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { splitValue } from '@intelligence/components/Filter/util';
import moment from 'moment';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';

export const getInitialFilterParams = (isOperate: boolean, filterExtend: any, defaultFilterParams: any): any => {
  if (!isOperate) return defaultFilterParams;

  const regionFilterExtend = filterExtend?.[REGION_SELECT_FILTER];
  const dataSourceFilterExtend = filterExtend?.[ICONABLE_CHECKBOX_SELECT_FILTER];
  const showHeatMapFilterExtend = filterExtend?.[HEAT_MAP_SELECT_FILTER];
  const showCountriesFilterExtend = filterExtend?.[SHOW_TOP_COUNTRIES_SELECT_FILTER];

  const initialRegionType = regionFilterExtend?.region_type || defaultFilterParams?.regionType;
  const initialRegionValue = regionFilterExtend?.region_values || defaultFilterParams?.regionValue;
  const initialDataSource =
    dataSourceFilterExtend?.value?.length > 0 ? dataSourceFilterExtend?.value : defaultFilterParams?.dataSource;
  const initialShowHeatMap = showHeatMapFilterExtend?.value || defaultFilterParams?.showHeatMap;
  const initialShowCountries = showCountriesFilterExtend?.value || defaultFilterParams?.showCountries;

  return {
    dataSource: initialDataSource,
    regionType: initialRegionType,
    regionValue: initialRegionValue,
    showHeatMap: initialShowHeatMap,
    showCountries: initialShowCountries,
  };
};


function validateAndExtract(str: string) {
  // 正则表达式以匹配"d数字-d数字"的格式
  let patternDay = /^d([1-9]\d{0,2})-d([1-9]\d{0,2})$/;
  let patternMonth = /^m([1-9]\d{0,1})-m([1-9]\d{0,1})$/;

  let matchesDay = str.match(patternDay);
  let matchesMonth = str.match(patternMonth);

  // 检查字符串是否匹配定义的格式
  if (matchesDay) {
    // 提取数字
    let value1 = parseInt(matchesDay[1], 10);
    let value2 = parseInt(matchesDay[2], 10);
    // 检查数字是否在1-365的范围内
    if (value1 >= 1 && value1 <= value2 && value2 <= 365) {
      return {
        "mode": ComposedDateMode.Relative,
        "dateType": "date",
        "dateValue": [
          value1.toString(), value2.toString()
        ]
      }
    }
  }
  // 检查字符串是否匹配定义的格式
  if (matchesMonth) {
    // 提取数字
    let value1 = parseInt(matchesMonth[1], 10);
    let value2 = parseInt(matchesMonth[2], 10);
    // 检查数字是否在1-365的范围内
    if (value1 >= 1 && value1 <= value2 && value2 <= 12) {
      return {
        "mode": ComposedDateMode.Relative,
        "dateType": "month",
        "dateValue": [
          value1.toString(), value2.toString()
        ]
      }
    }
  }
  return;
}

export const getLaunchTimeUrlValues = (history: any) => {
  const { query } = history.location || {};
  //获取LaunchTime筛选器url值
  const launchTime = query?.launchTime;
  const [timeTypeOrValue, start, end] = splitValue(launchTime);
  if (
    ['day', 'date', 'week', 'month']?.includes(timeTypeOrValue) &&
    moment(start).isValid() &&
    moment(end).isValid() &&
    (moment(start) <= moment(end))
  ) {
    let timeValues = [
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
    ];
    if (timeTypeOrValue === 'month') {
      timeValues = [moment(start).startOf("month").format('YYYY-MM-DD'),
      moment(end).endOf("month").format('YYYY-MM-DD')];
    }
    const timeParams = {
      mode: ComposedDateMode.Absolute,
      dateType: timeTypeOrValue === 'day' ? 'date' : timeTypeOrValue,
      dateValue: timeValues,
    };
    return timeParams
  } else if (timeTypeOrValue) {
    const timeParams = validateAndExtract(timeTypeOrValue);
    if (timeParams) {
      return timeParams
    }
  }

  return;

}

export const getCompareisCustomVaildUrlParams = (history: any) => {
  const { query } = history.location || {};
  const gameids = splitValue(query?.gameids)?.slice(0, 6);
  //请做错误判断处理
  const nikkeParams = {
    game_ids: gameids?.length > 0 ? gameids : [],
  };

  return nikkeParams;
};

/*
/intelligence/topCharts/mobileGames?launchTime=d1,d30&region=jp
&gameids=u72c49cf5c8b11337fb27bdf8c21976e7,ucaa4c3ede87e6e67f8daf205f95a7ca4,u64028205232ab52da75f9091fdf68127
&gameids=udcba528a7c314262d50dfdcb71591be9,u05b9e0a7b707321f04a1faafdb5d3668,u5e1377d1d8f578e11804459e6c252834,
&gameids=u9495a569f462cf137e7289680423c952,u1a2dd91587c4d17519f6dc527efbb2d7,u799fa40a5a7b726d0c6f14d08f5b7bfc
&dataSource=appannie&pageSize=50&topSelect=10&order=desc&orderMetric=revenue

*/